import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryCards() {
  const icons: Record<string, string> = {
    'qinggan-gushi': 'ri-heart-line',
    'chengzhang-jiyi': 'ri-seedling-line',
    'xinli-fenxi': 'ri-brain-line',
    'qingchun-wenxue': 'ri-book-open-line',
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">探索内容分类</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">从不同维度，重新走进那段青春记忆</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors duration-200">
                <i className={`${icons[cat.slug] || 'ri-folder-line'} text-2xl text-accent-700`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}